import Http from './http'
import {The_Ability} from '../store/index'


import Vue from 'vue'

export default {
	index(filter){
    console.log({ax: Vue.axios.defaults})
    return Vue.axios.get('/solutions', {
      params: {
        ...filter
      }
    })
  },


  indexLean(filter){
    return Http.get(`/solutions_lean`, {params: {...filter}});
  },

  show(id){
    return Http.get(`/solutions/${id}`)
  },


  create(new_solution){
    if (The_Ability.can('manage', 'Checkbits')){
      return Http.post(`/solutions`,{
        solution:{ 
          ...new_solution
        }
      });
    } else {
      return false
    }
  },
  update(update_solution){
    if (The_Ability.can('manage', 'Checkbits')){
      return Http.put(`/solutions/${update_solution.id}`,{
        solution:{ 
          ...update_solution
        }
      });
    } else {
      return false
    }
  },
}